import { Model, PagedResponse } from "@ofqual/portal-core/core/types";
import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import { dataPortalLookupService } from "../services";
import {
  ActionPayload,
  LOADING_DATA_PORTAL_LOOKUP_LIST,
  loadedDataPortalLookups,
  UPDATING_DATA_PORTAL_LOOKUP_LIST,
  updatedDataPortalLookups,
  LOADING_DATA_PORTAL_PREVIOUS_LIST,
  loadedDataPortalPreviousLookups,
  SUBMIT_RETURN,
  SUBMIT_NIL_RETURN,
  failedReturn,
  successReturn,
  errorReturn,
} from "./actions";
import { authSelector } from "./selectors";
import { PendingReturn } from "../domain/PendingReturn";

// function* navigate(url: string) {
//   const history: History = yield getContext("history");
//   yield call(() => history.push(url));
// }

function* watchDataPortalLookupsSaga() {
  yield takeLatest(LOADING_DATA_PORTAL_LOOKUP_LIST, dataPortalLookupsSaga);
}

function* watchUpdateDataImporterLookupSaga() {
  yield takeEvery(UPDATING_DATA_PORTAL_LOOKUP_LIST, updateDataPortalLookupSaga);
}

function* watchDataPortalPreviousLookupSaga() {
  yield takeLatest(
    LOADING_DATA_PORTAL_PREVIOUS_LIST,
    dataPortalPreviousLookupsSaga
  );
}

function* watchSubmitReturn() {
  yield takeEvery(SUBMIT_RETURN, submitReturn);
}

function* watchSubmitNilReturn() {
  yield takeEvery(SUBMIT_NIL_RETURN, submitNilReturn);
}

function* dataPortalLookupsSaga({ payload }: ActionPayload<{ orgId: number }>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const items: PagedResponse<PendingReturn> = yield call(
    [dataPortalLookupService, dataPortalLookupService.get],
    payload.orgId,
    {
      token: auth.token,
    }
  );
  yield put(loadedDataPortalLookups(items));
}

function* dataPortalPreviousLookupsSaga({
  payload,
}: ActionPayload<{ orgId: number }>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);

  const items: PagedResponse<PendingReturn> = yield call(
    [dataPortalLookupService, dataPortalLookupService.getArchive],
    payload.orgId,
    {
      token: auth.token,
    }
  );
  yield put(loadedDataPortalPreviousLookups(items));
}

function* updateDataPortalLookupSaga({ payload }: ActionPayload<any>) {
  const auth: ReturnType<typeof authSelector> = yield select(authSelector);
  const { updates } = payload;
  yield call(
    [dataPortalLookupService, dataPortalLookupService.update],
    updates,
    { token: auth.token }
  );

  yield put(updatedDataPortalLookups());
}

function* submitReturn({
  payload,
}: ActionPayload<{
  fileName: string;
  collectionAoId: number;
  templateId: number;
}>) {
  const { token }: ReturnType<typeof authSelector> = yield select(authSelector);
  const { fileName, collectionAoId, templateId } = payload;
  try {
    const response: Model = yield call(
      [dataPortalLookupService, dataPortalLookupService.submitReturn],
      fileName,
      collectionAoId,
      templateId,
      { token }
    );
    if (!response.message || !response.message.includes("SUCCESS")) {
      yield put(failedReturn(collectionAoId, templateId, response.message));
    } else {
      yield put(successReturn(collectionAoId, templateId));
    }
  } catch (err) {
    yield put(errorReturn(collectionAoId, templateId));
  }
}

function* submitNilReturn({
  payload,
}: ActionPayload<{ collectionAoId: number; templateId: number }>) {
  const { token }: ReturnType<typeof authSelector> = yield select(authSelector);
  const { collectionAoId, templateId } = payload;
  try {
    const response: Model = yield call(
      [dataPortalLookupService, dataPortalLookupService.submitNilReturn],
      collectionAoId,
      templateId,
      { token }
    );
    // if (!response.message || !response.message.includes("SUCCESS")) {
    if (response.status === 200) {
      yield put(failedReturn(collectionAoId, templateId));
    } else {
      yield put(successReturn(collectionAoId, templateId));
    }
  } catch (err) {
    yield put(errorReturn(collectionAoId, templateId));
  }
}

export function* rootSaga() {
  yield all([
    watchDataPortalLookupsSaga(),
    watchUpdateDataImporterLookupSaga(),
    watchDataPortalPreviousLookupSaga(),
    watchSubmitReturn(),
    watchSubmitNilReturn(),
  ]);
}
